import { consts } from '@/services/utilities'
export const getMenuData = [
  {
    category: true,
    title: 'Instituciones',
    roles: [consts.rolesText.SU],
    permissions: [
      consts.permissions.CREATE_SU_MANAGEMENT,
      consts.permissions.UPDATE_SU_MANAGEMENT,
      consts.permissions.DELETE_SU_MANAGEMENT,
    ],
  },
  {
    title: 'Instituciones',
    key: 'instituciones',
    icon: 'fa fa-building',
    permissions: [
      consts.permissions.CREATE_SU_MANAGEMENT,
      consts.permissions.UPDATE_SU_MANAGEMENT,
      consts.permissions.DELETE_SU_MANAGEMENT,
    ],
    children: [
      {
        title: 'Lista de instituciones',
        key: 'institucionesLista',
        url: '/schools',
        roles: [consts.rolesText.SU],
        permissions: [
          consts.permissions.CREATE_SU_MANAGEMENT,
          consts.permissions.UPDATE_SU_MANAGEMENT,
          consts.permissions.DELETE_SU_MANAGEMENT,
        ],
      },
      {
        title: 'Crear insitución',
        key: 'institucionesCrear',
        url: '/schools/create',
        roles: [consts.rolesText.SU],
        permissions: [
          consts.permissions.CREATE_SU_MANAGEMENT,
          consts.permissions.UPDATE_SU_MANAGEMENT,
          consts.permissions.DELETE_SU_MANAGEMENT,
        ],
      },
    ],
  },
  {
    category: true,
    title: 'Rutas, roles y permisos',
    roles: [consts.rolesText.SU],
    permissions: [
      consts.permissions.CREATE_SU_MANAGEMENT,
      consts.permissions.UPDATE_SU_MANAGEMENT,
      consts.permissions.DELETE_SU_MANAGEMENT,
    ],
  },
  {
    title: 'Rutas, roles y permisos',
    key: 'Rutas',
    icon: 'fa fa-key',
    permissions: [
      consts.permissions.CREATE_SU_MANAGEMENT,
      consts.permissions.UPDATE_SU_MANAGEMENT,
      consts.permissions.DELETE_SU_MANAGEMENT,
    ],
    children: [
      {
        title: 'Lista de Rutas',
        key: 'ListaRutas',
        url: '/routes-management',
        roles: [consts.rolesText.SU],
        permissions: [
          consts.permissions.CREATE_SU_MANAGEMENT,
          consts.permissions.UPDATE_SU_MANAGEMENT,
          consts.permissions.DELETE_SU_MANAGEMENT,
        ],
      },
      {
        title: 'Lista de Roles',
        key: 'RolesLista',
        url: '/roles',
        roles: [consts.rolesText.SU],
        permissions: [
          consts.permissions.CREATE_SU_MANAGEMENT,
          consts.permissions.UPDATE_SU_MANAGEMENT,
          consts.permissions.DELETE_SU_MANAGEMENT,
        ],
      },
      {
        title: 'Lista de permisos',
        key: 'PermisosLista',
        url: '/permissions',
        roles: [consts.rolesText.SU],
        permissions: [
          consts.permissions.CREATE_SU_MANAGEMENT,
          consts.permissions.UPDATE_SU_MANAGEMENT,
          consts.permissions.DELETE_SU_MANAGEMENT,
        ],
      },
    ],
  },
  {
    category: true,
    title: 'Errores capturados',
    roles: [consts.rolesText.SU],
    permissions: [
      consts.permissions.DELETE_SU_MANAGEMENT,
    ],
  },
  {
    title: 'Bugs',
    key: 'Bugs',
    icon: 'fa fa-bug',
    permissions: [
      consts.permissions.DELETE_SU_MANAGEMENT,
    ],
    children: [
      {
        title: 'Lista de errores',
        key: 'ListaRutas',
        url: '/register-error',
        roles: [consts.rolesText.SU],
        permissions: [
          consts.permissions.DELETE_SU_MANAGEMENT,
        ],
      },
    ],
  },
  {
    category: true,
    title: 'Usuarios',
    roles: [consts.rolesText.ADMIN, consts.rolesText.ADMIN_ACADEMICO, consts.rolesText.GESTOR_ACADEMICO, consts.rolesText.ADMIN_RESTAURANTE, consts.rolesText.RECARGADOR, consts.rolesText.CAJERO],
    permissions: [consts.permissions.CREATE_USER],
  },
  {
    title: 'Usuarios',
    key: 'usuarios',
    icon: 'fa fa-group',
    permissions: [
      consts.permissions.CREATE_USER,
      consts.permissions.UPDATE_USER,
      consts.permissions.UPDATE_USER_PHOTO,
      consts.permissions.UPDATE_USER_CODE_CARD,
    ],
    children: [
      {
        title: 'Lista de usuarios',
        key: 'usuariosLista',
        url: '/users',
        roles: [consts.rolesText.ADMIN, consts.rolesText.ADMIN_ACADEMICO, consts.rolesText.GESTOR_ACADEMICO, consts.rolesText.ADMIN_RESTAURANTE, consts.rolesText.RECARGADOR, consts.rolesText.CAJERO],
        permissions: [consts.permissions.READ_USERS],
      },
      {
        title: 'Crear usuario',
        key: 'usuariosCrear',
        url: '/users/create',
        roles: [consts.rolesText.ADMIN, consts.rolesText.ADMIN_ACADEMICO, consts.rolesText.GESTOR_ACADEMICO, consts.rolesText.ADMIN_RESTAURANTE],
        permissions: [
          consts.permissions.CREATE_USER,
          consts.permissions.UPDATE_USER,
          consts.permissions.UPDATE_USER_PHOTO,
          consts.permissions.UPDATE_USER_CODE_CARD,
        ],
      },
    ],
  },
  {
    category: true,
    title: 'Académico',
    roles: [consts.rolesText.ADMIN, consts.rolesText.ADMIN_ACADEMICO, consts.rolesText.COORDINADOR, consts.rolesText.GESTOR_ACADEMICO, consts.rolesText.DOCENTE, consts.rolesText.ESTUDIANTE, consts.rolesText.PADRE_MADRE, consts.rolesText.BIBLIOTECARIO, consts.rolesText.CONTADOR],
    permissions: [consts.permissions.READ_ACADEMIC_INFORMATION],
    module: 'academicModule',
  },
  {
    title: 'Académico',
    key: 'academico',
    icon: 'fa fa-graduation-cap',
    permissions: [consts.permissions.READ_ACADEMIC_INFORMATION],
    module: 'academicModule',
    children: [
      {
        title: 'Clases',
        key: 'clases',
        url: '/classes',
        roles: [consts.rolesText.ADMIN, consts.rolesText.ADMIN_ACADEMICO, consts.rolesText.COORDINADOR, consts.rolesText.GESTOR_ACADEMICO, consts.rolesText.DOCENTE, consts.rolesText.ESTUDIANTE, consts.rolesText.PADRE_MADRE],
        permissions: [consts.permissions.READ_ACADEMIC_INFORMATION],
      },
      {
        title: 'Banco de indicadores',
        key: 'performance',
        url: '/performance',
        roles: [consts.rolesText.ADMIN, consts.rolesText.ADMIN_ACADEMICO, consts.rolesText.COORDINADOR, consts.rolesText.GESTOR_ACADEMICO, consts.rolesText.DOCENTE],
        permissions: [consts.permissions.CREATE_CLASSES_RESOURCES, consts.permissions.UPDATE_CLASSES_RESOURCES, consts.permissions.DELETE_CLASSES_RESOURCES],
      },
      {
        title: 'Banco de descriptores',
        key: 'descriptorBank',
        url: '/descriptors',
        roles: [consts.rolesText.ADMIN, consts.rolesText.ADMIN_ACADEMICO, consts.rolesText.COORDINADOR, consts.rolesText.GESTOR_ACADEMICO, consts.rolesText.DOCENTE],
        permissions: [consts.permissions.CREATE_CLASSES_RESOURCES, consts.permissions.UPDATE_CLASSES_RESOURCES, consts.permissions.DELETE_CLASSES_RESOURCES],
      },
      {
        title: 'Observador',
        key: 'observador',
        url: '/viewer',
        roles: [consts.rolesText.ADMIN, consts.rolesText.ADMIN_ACADEMICO, consts.rolesText.COORDINADOR, consts.rolesText.GESTOR_ACADEMICO, consts.rolesText.DOCENTE, consts.rolesText.ESTUDIANTE, consts.rolesText.PADRE_MADRE],
      },
      {
        title: 'Perfil',
        key: 'academicProfile',
        url: '/academico/perfil',
      },
    ],
  },
  {
    category: true,
    title: 'Observador',
    permissions: [consts.permissions.READ_OBSERVATIONS, consts.permissions.READ_OBSERVATIONS_CHILDREN],
    module: 'observerModule',
  },
  {
    title: 'Observador',
    key: 'observador',
    icon: 'fa fa-eye',
    permissions: [consts.permissions.READ_OBSERVATIONS, consts.permissions.READ_OBSERVATIONS_CHILDREN],
    module: 'observerModule',
    children: [
      {
        title: 'Gestión de observaciones',
        key: 'observationsManagement',
        url: '/observations/management',
        permissions: [consts.permissions.CREATE_OBSERVATIONS],
      },
      {
        title: 'Mi observador',
        key: 'observationsMyReport',
        url: '/observations/my-report',
        permissions: [consts.permissions.READ_OBSERVATIONS],
      },
      {
        title: 'Observador del estudiante',
        key: 'observationsMyChildren',
        url: '/observations/my-children',
        permissions: [consts.permissions.READ_OBSERVATIONS_CHILDREN],
      },
    ],
  },
  {
    title: 'Biblioteca',
    key: 'biblioteca',
    icon: 'fa fa-book',
    children: [
      {
        title: 'Biblioteca',
        key: 'bibliotecaInicio',
        url: '/library',
        roles: [consts.rolesText.ADMIN, consts.rolesText.ADMIN_ACADEMICO, consts.rolesText.COORDINADOR, consts.rolesText.GESTOR_ACADEMICO, consts.rolesText.DOCENTE, consts.rolesText.ESTUDIANTE, consts.rolesText.BIBLIOTECARIO],
      },
    ],
  },
  {
    category: true,
    title: 'Restaurante',
    roles: [consts.rolesText.ADMIN, consts.rolesText.ADMIN_ACADEMICO, consts.rolesText.ADMIN_RESTAURANTE, consts.rolesText.COORDINADOR, consts.rolesText.GESTOR_ACADEMICO, consts.rolesText.DOCENTE, consts.rolesText.ESTUDIANTE, consts.rolesText.PADRE_MADRE, consts.rolesText.CAJERO, consts.rolesText.RECARGADOR, consts.rolesText.VISITANTE],
    permissions: [
      consts.permissions.READ_OWN_RECHARGE,
      consts.permissions.STATISTICS_OWN_RECHARGES_SALES,
    ],
    module: 'cafeteriaModule',
  },
  {
    title: 'Restaurante/Cafetería',
    key: 'restaurante',
    icon: 'fa fa-cutlery',
    permissions: [
      consts.permissions.READ_OWN_RECHARGE,
      consts.permissions.STATISTICS_OWN_RECHARGES_SALES,
    ],
    module: 'cafeteriaModule',
    children: [
      {
        title: 'Venta',
        key: 'restauranteVenta',
        url: '/sales',
        roles: [consts.rolesText.ADMIN, consts.rolesText.ADMIN_RESTAURANTE, consts.rolesText.CAJERO],
        permissions: [
          consts.permissions.CREATE_INVOICE,
          consts.permissions.DELETE_SALE,
          consts.permissions.DELETE_PRODUCT_SALE,
        ],
      },
      {
        title: 'Productos',
        key: 'restauranteProductos',
        url: '/sales/products',
        roles: [consts.rolesText.ADMIN, consts.rolesText.ADMIN_RESTAURANTE],
        permissions: [
          consts.permissions.CREATE_PRODUCT,
          consts.permissions.EDIT_PRODUCT,
        ],
      },
      {
        title: 'Recargas',
        key: 'restauranteRecargas',
        url: '/sales/recharges',
        roles: [consts.rolesText.ADMIN, consts.rolesText.ADMIN_RESTAURANTE, consts.rolesText.RECARGADOR],
        permissions: [
          consts.permissions.CREATE_RECHARGE,
          consts.permissions.EDITRECHARGE,
        ],
      },
      {
        title: 'Gestión de ventas',
        key: 'management',
        url: '/sales/management',
        roles: [consts.rolesText.ADMIN, consts.rolesText.ADMIN_RESTAURANTE, consts.rolesText.RECARGADOR],
        permissions: [
          consts.permissions.STATISTICS_RECHARGES_SALES,
          consts.permissions.READ_SALES,
        ],
      },
      {
        title: 'Mi reporte',
        key: 'restauranteMiReporte',
        url: '/sales/my-report',
        roles: [consts.rolesText.ADMIN, consts.rolesText.ADMIN_ACADEMICO, consts.rolesText.ADMIN_RESTAURANTE, consts.rolesText.COORDINADOR, consts.rolesText.GESTOR_ACADEMICO, consts.rolesText.DOCENTE, consts.rolesText.ESTUDIANTE, consts.rolesText.PADRE_MADRE, consts.rolesText.CAJERO, consts.rolesText.RECARGADOR, consts.rolesText.VISITANTE],
        permissions: [
          consts.permissions.STATISTICS_OWN_RECHARGES_SALES,
        ],
      },
      {
        title: 'Reportes',
        key: 'restauranteReportes',
        url: '/sales/reports',
        roles: [consts.rolesText.ADMIN, consts.rolesText.ADMIN_RESTAURANTE, consts.rolesText.RECARGADOR],
        permissions: [
          consts.permissions.STATISTICS_RECHARGES_SALES,
        ],
      },
      {
        title: 'Control parental',
        key: 'restauranteControlParental',
        url: '/sales/parental-control',
        roles: [consts.rolesText.PADRE_MADRE],
        permissions: [
          consts.permissions.READ_CONTROL_PARENTAL,
          consts.permissions.CREATE_CONTROL_PARENTAL,
          consts.permissions.EDIT_CONTROL_PARENTAL,
          consts.permissions.DELETE_CONTROL_PARENTAL,
        ],
      },
    ],
  },
  {
    category: true,
    title: 'Nómina',
    permissions: [
      'readEmployees',
    ],
    module: 'payrollModule',
  },
  {
    title: 'Nómina',
    key: 'nomina',
    icon: 'fa fa-address-book-o',
    permissions: [
      'readEmployees',
    ],
    module: 'payrollModule',
    children: [
      {
        title: 'Empleados',
        key: 'empleados',
        url: '/employees',
        permissions: [
          'readEmployees',
        ],
      },
      {
        title: 'Nómina',
        key: 'nominaInicio',
        url: '/payrolls/periods',
        permissions: [
          'readEmployees',
        ],
      },
      // {
      //   title: 'Configuración',
      //   key: 'configuracion',
      //   url: '/payroll/settings',
      //   permissions: [
      //     'readEmployees',
      //   ],
      // },
    ],
  },
  {
    title: 'Tesorería',
    key: 'tesoreria',
    icon: 'fa fa-bar-chart-o',
    children: [
      {
        title: 'Tesorería',
        key: 'tesoreriaInicio',
        url: '/treasury',
        roles: [consts.rolesText.ADMIN],
      },
    ],
  },
  {
    category: true,
    title: 'Asistencia',
    roles: [consts.rolesText.SU, consts.rolesText.ADMIN, consts.rolesText.ADMIN_ACADEMICO, consts.rolesText.COORDINADOR, consts.rolesText.GESTOR_ACADEMICO],
  },
  {
    title: 'Asistencia',
    key: 'Asistencia',
    icon: 'fa fa-clock-o',
    children: [
      {
        title: 'Asistencia',
        key: 'asistenciaInicio',
        url: '/attendance',
        roles: [consts.rolesText.SU, consts.rolesText.ADMIN, consts.rolesText.ADMIN_ACADEMICO, consts.rolesText.GESTOR_ACADEMICO],
      },
      {
        title: 'Registro',
        key: 'register',
        url: '/register',
        roles: [consts.rolesText.SU, consts.rolesText.ADMIN, consts.rolesText.ADMIN_ACADEMICO, consts.rolesText.GESTOR_ACADEMICO],
      },
    ],
  },
  // {
  //   category: true,
  //   title: 'Evento',
  //   permissions: [
  //     consts.permissions.CREATE_USER,
  //   ],
  // },
  // {
  //   title: 'Evento',
  //   key: 'Evento',
  //   icon: 'fa fa-clock-o',
  //   permissions: [
  //     consts.permissions.CREATE_USER,
  //   ],
  //   children: [
  //     {
  //       title: 'Boletería',
  //       key: 'tickets',
  //       url: '/closing/tickets',
  //       permissions: [
  //         consts.permissions.CREATE_USER,
  //       ],
  //     },
  //   ],
  // },
  // {
  //   category: true,
  //   title: 'Dashboards',
  // },
  // {
  //   title: 'Dashboards',
  //   key: 'dashboards',
  //   icon: 'fe fe-home',
  //   roles: ['ADMIN', 'ADMIN_RESTAURANTE', 'CAJERO', 'RECARGADOR', 'DOCENTE', 'ESTUDIANTE', 'PADRE_MADRE'],
  //   count: 4,
  //   children: [
  //     {
  //       title: 'Dashboard Alpha',
  //       key: 'dashboard',
  //       url: '/dashboard/alpha',
  //       roles: ['ADMIN', 'ADMIN_RESTAURANTE', 'CAJERO', 'RECARGADOR', 'DOCENTE', 'ESTUDIANTE', 'PADRE_MADRE'],
  //     },
  //     {
  //       title: 'Dashboard Beta',
  //       key: 'dashboardBeta',
  //       url: '/dashboard/beta',
  //       roles: ['ADMIN', 'ADMIN_RESTAURANTE', 'CAJERO', 'RECARGADOR', 'DOCENTE', 'ESTUDIANTE', 'PADRE_MADRE'],
  //     },
  //     {
  //       title: 'Dashboard Gamma',
  //       key: 'dashboardGamma',
  //       url: '/dashboard/gamma',
  //       roles: ['ADMIN', 'ADMIN_RESTAURANTE', 'CAJERO', 'RECARGADOR', 'DOCENTE', 'ESTUDIANTE', 'PADRE_MADRE'],
  //     },
  //     {
  //       title: 'Crypto Terminal',
  //       key: 'dashboardCrypto',
  //       url: '/dashboard/crypto',
  //       roles: ['ADMIN', 'ADMIN_RESTAURANTE', 'CAJERO', 'RECARGADOR', 'DOCENTE', 'ESTUDIANTE', 'PADRE_MADRE'],
  //     },
  //   ],
  // },
]
